import x43 from '../../../images/Suikoden/SonyaAnyPercent/Sonyax43.png';
import x44 from '../../../images/Suikoden/SonyaAnyPercent/Sonyax44.png';
import x45 from '../../../images/Suikoden/SonyaAnyPercent/Sonyax45.png';
import x46 from '../../../images/Suikoden/SonyaAnyPercent/Sonyax46.png';
import x47 from '../../../images/Suikoden/SonyaAnyPercent/Sonyax47.png';
import x48 from '../../../images/Suikoden/SonyaAnyPercent/Sonyax48.png';
import x49 from '../../../images/Suikoden/SonyaAnyPercent/Sonyax49.png';
import x4a from '../../../images/Suikoden/SonyaAnyPercent/Sonyax4a.png';
import x4b from '../../../images/Suikoden/SonyaAnyPercent/Sonyax4b.png';
import x4c from '../../../images/Suikoden/SonyaAnyPercent/Sonyax4c.png';
import x4d from '../../../images/Suikoden/SonyaAnyPercent/Sonyax4d.png';
import x4e from '../../../images/Suikoden/SonyaAnyPercent/Sonyax4e.png';
import x4f from '../../../images/Suikoden/SonyaAnyPercent/Sonyax4f.png';
import x50 from '../../../images/Suikoden/SonyaAnyPercent/Sonyax50.png';
import x51 from '../../../images/Suikoden/SonyaAnyPercent/Sonyax51.png';
import x52 from '../../../images/Suikoden/SonyaAnyPercent/Sonyax52.png';
import x53 from '../../../images/Suikoden/SonyaAnyPercent/Sonyax53.png';
import x54 from '../../../images/Suikoden/SonyaAnyPercent/Sonyax54.png';
import x55 from '../../../images/Suikoden/SonyaAnyPercent/Sonyax55.png';
import x56 from '../../../images/Suikoden/SonyaAnyPercent/Sonyax56.png';
import x57 from '../../../images/Suikoden/SonyaAnyPercent/Sonyax57.png';
import x58 from '../../../images/Suikoden/SonyaAnyPercent/Sonyax58.png';
import x59 from '../../../images/Suikoden/SonyaAnyPercent/Sonyax59.png';
import x5a from '../../../images/Suikoden/SonyaAnyPercent/Sonyax5a.png';
import x5b from '../../../images/Suikoden/SonyaAnyPercent/Sonyax5b.png';
import x5c from '../../../images/Suikoden/SonyaAnyPercent/Sonyax5c.png';
import x5d from '../../../images/Suikoden/SonyaAnyPercent/Sonyax5d.png';
import x5e from '../../../images/Suikoden/SonyaAnyPercent/Sonyax5e.png';
import x5f from '../../../images/Suikoden/SonyaAnyPercent/Sonyax5f.png';

export default [
  {
    image: x43,
    additionalInfo: [],
    seed: '0x43',
    main: {
      vertical: 'Bottom',
      horizontal: 'Left'
    },
    secondary: {
      vertical: 'Top',
      horizontal: 'Right'
    }
  },
  {
    image: x44,
    additionalInfo: [],
    seed: '0x44',
    main: {
      vertical: 'Middle',
      horizontal: 'Right'
    },
    secondary: {
      vertical: 'Top',
      horizontal: 'Left'
    }
  },
  {
    image: x45,
    additionalInfo: [],
    seed: '0x45',
    main: {
      vertical: 'Bottom',
      horizontal: 'Middle'
    },
    secondary: {
      vertical: 'Middle',
      horizontal: 'Middle'
    }
  },
  {
    image: x46,
    additionalInfo: [],
    seed: '0x46',
    main: {
      vertical: 'Middle',
      horizontal: 'Left'
    },
    secondary: {
      vertical: 'Top',
      horizontal: 'Right'
    }
  },
  {
    image: x47,
    additionalInfo: [],
    seed: '0x47',
    main: {
      vertical: 'Bottom',
      horizontal: 'Right'
    },
    secondary: {
      vertical: 'Bottom',
      horizontal: 'Left'
    }
  },
  {
    image: x48,
    additionalInfo: [],
    seed: '0x48',
    main: {
      vertical: 'Middle',
      horizontal: 'Middle'
    },
    secondary: {
      vertical: 'Top',
      horizontal: 'Middle'
    }
  },
  {
    image: x49,
    additionalInfo: [],
    seed: '0x49',
    main: {
      vertical: 'Top',
      horizontal: 'Left'
    },
    secondary: {
      vertical: 'Top',
      horizontal: 'Left'
    }
  },
  {
    image: x4a,
    additionalInfo: [],
    seed: '0x4a',
    main: {
      vertical: 'Middle',
      horizontal: 'Right'
    },
    secondary: {
      vertical: 'Middle',
      horizontal: 'Left'
    }
  },
  {
    image: x4b,
    additionalInfo: [],
    seed: '0x4b',
    main: {
      vertical: 'Top',
      horizontal: 'Middle'
    },
    secondary: {
      vertical: 'Top',
      horizontal: 'Left'
    }
  },
  {
    image: x4c,
    additionalInfo: [],
    seed: '0x4c',
    main: {
      vertical: 'Bottom',
      horizontal: 'Left'
    },
    secondary: {
      vertical: 'Middle',
      horizontal: 'Right'
    }
  },
  {
    image: x4d,
    additionalInfo: [],
    seed: '0x4d',
    main: {
      vertical: 'Top',
      horizontal: 'Middle'
    },
    secondary: {
      vertical: 'Bottom',
      horizontal: 'Right'
    }
  },
  {
    image: x4e,
    additionalInfo: [],
    seed: '0x4e',
    main: {
      vertical: 'Middle',
      horizontal: 'Bottom'
    },
    secondary: {
      vertical: 'Top',
      horizontal: 'Left'
    }
  },
  {
    image: x4f,
    additionalInfo: [],
    seed: '0x4f',
    main: {
      vertical: 'Top',
      horizontal: 'Right'
    },
    secondary: {
      vertical: 'Bottom',
      horizontal: 'Right'
    }
  },
  {
    image: x50,
    additionalInfo: [],
    seed: '0x50',
    main: {
      vertical: 'Bottom',
      horizontal: 'Middle'
    },
    secondary: {
      vertical: 'Middle',
      horizontal: 'Right'
    }
  },
  {
    image: x51,
    additionalInfo: [],
    seed: '0x51',
    main: {
      vertical: 'Middle',
      horizontal: 'Middle'
    },
    secondary: {
      vertical: 'Top',
      horizontal: 'Left'
    }
  },
  {
    image: x52,
    additionalInfo: [],
    seed: '0x52',
    main: {
      vertical: 'Bottom',
      horizontal: 'Right'
    },
    secondary: {
      vertical: 'Bottom',
      horizontal: 'Right'
    }
  },
  {
    image: x53,
    additionalInfo: [],
    seed: '0x53',
    main: {
      vertical: 'Middle',
      horizontal: 'Middle'
    },
    secondary: {
      vertical: 'Bottom',
      horizontal: 'Right'
    }
  },
  {
    image: x54,
    additionalInfo: [],
    seed: '0x54',
    main: {
      vertical: 'Top',
      horizontal: 'Left'
    },
    secondary: {
      vertical: 'Bottom',
      horizontal: 'Middle'
    }
  },
  {
    image: x55,
    additionalInfo: [],
    seed: '0x55',
    main: {
      vertical: 'Bottom',
      horizontal: 'Right'
    },
    secondary: {
      vertical: 'Top',
      horizontal: 'Middle'
    }
  },
  {
    image: x56,
    additionalInfo: [],
    seed: '0x56',
    main: {
      vertical: 'Top',
      horizontal: 'Middle'
    },
    secondary: {
      vertical: 'Middle',
      horizontal: 'Middle'
    }
  },
  {
    image: x57,
    additionalInfo: ['Hard to see'],
    seed: '0x57',
    main: {
      vertical: 'Bottom',
      horizontal: 'Left'
    },
    secondary: {
      vertical: 'Bottom',
      horizontal: 'Right'
    }
  },
  {
    image: x58,
    additionalInfo: [],
    seed: '0x58',
    main: {
      vertical: 'Bottom',
      horizontal: 'Right'
    },
    secondary: {
      vertical: 'Bottom',
      horizontal: 'Left'
    }
  },
  {
    image: x59,
    additionalInfo: [],
    seed: '0x59',
    main: {
      vertical: 'Bottom',
      horizontal: 'Middle'
    },
    secondary: {
      vertical: 'Bottom',
      horizontal: 'Middle'
    }
  },
  {
    image: x5a,
    additionalInfo: [],
    seed: '0x5a',
    main: {
      vertical: 'Middle',
      horizontal: 'Left'
    },
    secondary: {
      vertical: 'Top',
      horizontal: 'Middle'
    }
  },
  {
    image: x5b,
    additionalInfo: [],
    seed: '0x5b',
    main: {
      vertical: 'Bottom',
      horizontal: 'Right'
    },
    secondary: {
      vertical: 'Bottom',
      horizontal: 'Left'
    }
  },
  {
    image: x5c,
    additionalInfo: [],
    seed: '0x5c',
    main: {
      vertical: 'Middle',
      horizontal: 'Middle'
    },
    secondary: {
      vertical: 'Bottom',
      horizontal: 'Middle'
    }
  },
  {
    image: x5d,
    additionalInfo: [],
    seed: '0x5d',
    main: {
      vertical: 'Top',
      horizontal: 'Left'
    },
    secondary: {
      vertical: 'Middle',
      horizontal: 'Middle'
    }
  },
  {
    image: x5e,
    additionalInfo: [ 'Hard to See' ],
    seed: '0x5e',
    main: {
      vertical: 'Bottom',
      horizontal: 'Right'
    },
    secondary: {
      vertical: 'Top',
      horizontal: 'Left'
    }
  },
  {
    image: x5f,
    additionalInfo: [],
    seed: '0x5f',
    main: {
      vertical: 'Top',
      horizontal: 'Middle'
    },
    secondary: {
      vertical: 'Middle',
      horizontal: 'Left'
    }
  }
]
